import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { LoadingIndicatorComponent, ScrollerComponent } from '@blaze-shared/shared-ui';

import { ChatConversation, ChatMessage, ChatSearchResult } from '../chat.models';
import { InitialsPipe } from '../user-avatar/initials.pipe';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

import { HighlightSearchResultPipe } from './highlight-search-result.directive';

@Component({
  selector: 'be-conversations-search-results',
  templateUrl: './conversations-search-results.component.html',
  styleUrls: ['./conversations-search-results.component.scss'],
  imports: [
    DatePipe,
    InitialsPipe,
    LoadingIndicatorComponent,
    ScrollerComponent,
    HighlightSearchResultPipe,
    UserAvatarComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationsSearchResultsComponent {
  searchResultsMessages = input<ChatSearchResult[]>([]);
  messagesLoading = input<boolean>(false);
  searchResultsChats = input<ChatConversation[]>([]);
  searchTerm = input<string>('');

  selectedMessageResult = output<ChatMessage>();
  selectedChatResult = output<ChatConversation>();

  includeSeparator = computed<boolean>(() => {
    return !!(this.searchResultsMessages().length && this.searchResultsChats().length);
  });

  onSelectedChatResult(chat: ChatConversation): void {
    this.selectedChatResult.emit(chat);
  }

  onSelectedMessageResult(message: ChatMessage): void {
    this.selectedMessageResult.emit(message);
  }
}
